import {
  ADD_TO_CART_DISPLAY_TYPE,
  AddToCart as AddToCartComponent,
} from './AddToCart';
import { withContainer } from './withContainer';

const AddToCart = withContainer(AddToCartComponent);

export {
  ADD_TO_CART_DISPLAY_TYPE,
  AddToCart,
  AddToCartComponent,
};
export * from './withContainer';
